import { UserLoginRole } from '../../enumeration/roles';
import { StoreData } from 'src/app/utils/store_data';
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { LogoutApiService } from 'src/app/services/logout_service.';
import { Refrsh } from 'src/app/utils/refresh';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouteLinkByRoles } from 'src/app/utils/route_by_role';
import { RebateType } from 'src/app/enumeration/rebateType';
import { CommonModule } from '@angular/common';
declare var $: any;

@Component({
  selector: 'app-nav',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
  ],
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})
export class NavComponent {

  sliderActive = false;
  changePasswordForm: FormGroup<any>;
  isError: any = false
  errorMessage: any;
  link: any
  showNewPassword: any = false
  showConfirmPassword: boolean = false
  isUploading: boolean = false
  loginName: any = ''

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private service: LogoutApiService,
    private store: StoreData,
    private refresh: Refrsh,
    private links: RouteLinkByRoles) {
    this.changePasswordForm = this.fb.group({
      newPassword: ['', Validators.required],
      confirmPassword: ['', Validators.required],
    })
  }

  ngOnInit(): void {
    const roleString = this.store.getRole(); // "ADMIN,DEALER_ADMIN"

    const roles: UserLoginRole[] = roleString
      .split(',')
      .map(r => r.trim() as UserLoginRole);

    let mergedLinks: any[] = [];

    // 🔹 SUPER_ADMIN
    if (roles.includes(UserLoginRole.SUPER_ADMIN)) {
      mergedLinks = [...mergedLinks, ...this.links.super_admin_links];
    }

    // 🔹 ADMIN
    if (roles.includes(UserLoginRole.ADMIN)) {
      mergedLinks = [...mergedLinks, ...this.links.admin_links];
    }

    // 🔹 DEALER_ADMIN
    if (roles.includes(UserLoginRole.DEALER_ADMIN)) {
      mergedLinks = [...mergedLinks, ...this.links.dealer_admin_links];
    }

    // 🔹 MDOFFICE_UPLOAD_ADMIN
    if (roles.includes(UserLoginRole.MDOFFICE_UPLOAD_ADMIN)) {
      mergedLinks = [...mergedLinks, ...this.links.mdo_admin_links];
    }

    // 🔹 FINANCE_UPLOAD_ADMIN
    if (roles.includes(UserLoginRole.FINANCE_UPLOAD_ADMIN)) {
      mergedLinks = [...mergedLinks, ...this.links.fid_admin_links];
    }

    // 🔹 PRICELIST_UPLOAD_ADMIN
    if (roles.includes(UserLoginRole.PRICELIST_UPLOAD_ADMIN)) {
      mergedLinks = [...mergedLinks, ...this.links.price_list_admin_links];
    }

    // 🔹 BW_ADMIN
    if (roles.includes(UserLoginRole.BW_ADMIN)) {
      mergedLinks = [...mergedLinks, ...this.links.bw_admin_links];
    }

    // 🔹 DEALER (special logic)
    if (roles.includes(UserLoginRole.DEALER)) {

      if (this.store.getRebateType().includes(RebateType.PREMIER_POINT)) {
        mergedLinks = [...mergedLinks, ...this.links.dealer_premier_links];
      } else {
        mergedLinks = [...mergedLinks, ...this.links.dealer_links];
      }
      this.store.setIsDealer(true)
    }

    // 🔥 Remove duplicate routes
    this.link = this.removeDuplicateLinks(mergedLinks);

    this.loginName = this.store.getLoginName()
  }

  private removeDuplicateLinks(links: any[]) {

    const unique = new Map<string, any>();

    links.forEach(link => {
      unique.set(link.link, link); // use route path as unique key
    });

    return Array.from(unique.values());
  }

  toggleSlider() {
    this.sliderActive = !this.sliderActive;
  }

  submitChangePassword() {
    const newPass = this.changePasswordForm.get('newPassword')?.value
    const confirmPass = this.changePasswordForm.get('confirmPassword')?.value
    if (newPass !== confirmPass) {
      this.isError = true
      this.errorMessage = 'Password does not match'
    } else {
      this.isError = false
      this.updatePassword(confirmPass)
    }
  }

  updatePassword(newPassword: any) {
    this.isUploading = true
    this, this.service.getUpdatePassword(newPassword).subscribe({
      next: (value) => {
        const loginName = this.store.getLoginName()
        var authorization = 'Basic ' + window.btoa(loginName + ':' + newPassword);
        this.store.setAuth(authorization)

        alert("Success")
      },
      error: (e) => {
        this.isUploading = false
        if (e) {
          this.isError = true
          this.errorMessage = e
        }
      },
      complete: () => {
        this.isUploading = false
        $('#changePasswordModal').modal('hide');
        this.isError = false
        this.errorMessage = ''
      },
    })
  }

  submitAdminLogout() {
    this.isUploading = true
    this.service.getLogout().subscribe({
      next: () => {
        sessionStorage.clear()
      },
      error: (e) => {
        this.isUploading = false
        if (e) {
          alert(e)
        }
      },
      complete: () => {
        this.isUploading = false
        $('#logoutModal').modal('hide');
        this.router.navigate(["/login"])
      }
    })

  }
}
